/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

     
        this.createSlider($sliderEl);
      
    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: this.products_per,
        products_available: this.products_available,
        products_limit: this.products_limit,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        groupCell:true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: false,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
        initialIndex: 4,
        arrowShape: arrowShape,
        on: {
          ready: function() {
            // Resize flickity when the slider is settled
            $sliderEl.on( 'settle.flickity', function() {
              $sliderEl.flickity('resize')
            });
          },
          scroll: function(progress){
              var progressBar = $sliderEl.parent().find('.progress-bar')
              progress = Math.max( 0, Math.min( 1, progress ) );
              $(progressBar).css('width',progress * 100 + '%')
  
          }
        }
      });
      $('ul.collection-list li').click(function(){
        $('ul.collection-list li').removeClass('active');
        $('.collection-blocks.active').removeClass('active');
       $(this).addClass('active'); 
        let getCollectionName = $(this).attr('data-collection');
        $('[data-collection="'+(getCollectionName)+'"]').addClass('active');
        $sliderEl.flickity('resize');
    });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;